const Blogs = () => {
    return(
        <>
            <h1>this is blog</h1>
        </>
    )
}

export default Blogs;